<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="shipmentInspects"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <!--        <el-button type="primary" :disabled="!selection.length" @click="printHandle"> 打印 </el-button>-->
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="createTime"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createTimeChange"/>
          </el-form-item>
          <el-form-item label="是否质检">
            <el-select v-model="filter.inspectionStatus" clearable>
              <el-option label="已质检" :value="1"/>
              <el-option label="未质检" :value="2"/>
              <el-option label="所有" :value="3"/>
            </el-select>
          </el-form-item>
          <el-form-item label="单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入单号" clearable/>
          </el-form-item>
          <el-form-item label="发货单号">
            <el-input v-model.trim="filter.deliveryBillNo" placeholder="请输入单号" clearable/>
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
          <el-form-item label="异常描述">
            <el-input v-model.trim="filter.processDesc" placeholder="请输入异常描述" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
          <el-form-item label="处理人">
            <el-input v-model.trim="filter.handleName" placeholder="请输入处理人" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <!--      <template slot="actionBtn" slot-scope="scope">-->
      <!--                <el-button-->
      <!--                    v-if="limits.subAuth"-->
      <!--                    type="primary"-->
      <!--                    :disabled="scope.row.status === 0"-->
      <!--                    :loading="submitLoading"-->
      <!--                    @click="submitHandle(scope.row)">-->
      <!--                  提交-->
      <!--                </el-button>-->
      <!--      </template>-->
    </viewTable>
    <shipment-inspect-edit ref="shipmentInspectEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ShipmentInspectEdit from "@/views/inspection/shipmentInspect/ShipmentInspectEdit";
  export default {
    name: "ShipmentInspectList",
    components: {ShipmentInspectEdit, viewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(582),
          editAuth: this.$auth(583),
          delAuth: this.$auth(584),
          subAuth: this.$auth(585),
        },
        submitLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selection: [],
        createTime: "",
        filter: {
          billNo: "",
          deliveryBillNo: "",
          processDesc: "",
          supplierName: "",
          handleName: "",
          beginCreateTime: "",
          endCreateTime: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: "",
          inspectionStatus: 3,
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            align: "center",
            width: 180,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/ShipmentInspectPreview",
                        query: {
                          billType: 13,
                          billId: params.row.pkid,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "isInspection",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                "span",
                params.row.isInspection?"是":"否",
              );
            },
          },
          {
            tooltip: true,
            key: "inspectionResult",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                "span",
                params.row.inspectionResult?"ok":"ng",
              );
            },
          },
          {
            tooltip: true,
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "deliveryBillNo",
            align: "center",
            width: 120,
          },
          {
            tooltip: true,
            key: "supplierName",
            align: "center",
            width: 210,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.shipmentInspectEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.get("basic", `shipmentInspects/submitOA/${row.pkid}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.submitLoading = false;
              this.loadData();
            } else {
              this.submitLoading = false;
            }
          }).catch(() => {
            this.submitLoading = false;
          },
          );
        });
      },
      createTimeChange(date) {
        if (date !== null) {
          this.filter.beginCreateTime = date[0];
          this.filter.endCreateTime = date[1];
        } else {
          this.filter.beginCreateTime = "";
          this.filter.endCreateTime = "";
        }
      },
      deleteHandle(row) {
        this.$http.delete("basic", "amerces", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      otherAuth(row) {
        return row.status === 0;
      },
    },
  };
</script>
